export const settingsSidebarEvents = [{
  heading: 'Журналы',
  navlinks: {
    events: 'События',
    notifications: 'Уведомления',
    'actions-user': 'Действия пользователя',
    'unsent-messages': 'Сообщения с ошибками',
    'channels-statistics': 'Статистика по каналам',
  },
},
{
  heading: 'Устройства',
  navlinks: {
    devices: 'Датчики',
  },
},
];
